// src/config/apiConfig.js

// .env 파일에 정의된 REACT_APP_API_URL 환경 변수 값
const BASE_URL = process.env.REACT_APP_API_URL;

if (!BASE_URL) {
    // 개발 환경에서 환경 변수 설정 누락 시 경고
    console.error("환경 변수 REACT_APP_API_URL이 설정되지 않았습니다. .env 파일을 확인해주세요.");
}

// API 기본 URL을 상수로 내보냄
export const API_BASE_URL = BASE_URL;

export const TEST_API_BASE_URL = "http://localhost:8081/api";

// 필요하다면 다른 상수 (예: API 타임아웃, 버전 등)도 여기에 정의
// export const API_TIMEOUT = 10000;